// const apiUrl = process.env.REACT_APP_API_URL;
const apiUrl = "https://adminblog.binaryparkme.com/api/";
export { apiUrl };
